import React from "react";
import { Routes, Route } from "react-router-dom";
// import classes from "./Landing.module.scss";
import MainRoutes from "./MainRoutes";
import useCard from "./useCard";
// import Loader from "../components/sharedUI/Loader/Loader";
import Error404 from "../components/Error/404";
import FatalError from "../components/Error/FatalError";
import NwError from "../components/Error/FatalError";
import { LoaderEle } from "../shared/SharedUtility";

const AppRoute = ({ navigateToSome }) => {
  const [isCardName, noCard, isTrackRet, noCardName] = useCard();


  return (
    <Routes>
      <Route
        exact
        path="/:cardName"
        element={
          isCardName ? <MainRoutes isTrackRet={isTrackRet} /> : <LoaderEle />
        }
      ></Route>
      <Route
        exact
        path="/error"
        element={noCard ? <Error404 /> : LoaderEle()}
      ></Route>
      <Route exact path="/networkerror" element={<NwError />}></Route>
      <Route exact path="/maintainance" element={<FatalError />}></Route>
      <Route exact path="/Error" element={<Error404 />}></Route>
      <Route
        exact
        path="/"
        element={noCardName ? <MainRoutes /> : LoaderEle()}
      ></Route>
    </Routes>
  );
};

export default AppRoute;
